import React, { useState } from 'react';
import { Modal, Alert, Button } from 'react-bootstrap';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { moneyFormat, getUnmetRequirements, unmetRequirementsMessage, getAnchorIds } from '../services/product';
import useQuoteModal from './useQuoteModal';
import { leadErrors } from '../services/requests';
import {GA_EVENT} from "../redux/app";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleNotch} from "@fortawesome/pro-light-svg-icons";
import "../scss/components/submitQuote.scss";
import Cookies from 'js-cookie';

function SubmitQuote({ config, quote, dispatch, total }) {
  const inputDefault = { first_name: '', last_name: '', email_address: '', contact_number: '' };
  const [modalVisible, setModalVisible] = useQuoteModal(false);
  const [inputs, setInputs] = useState(inputDefault);
  const [saved, setSaved] = useState(false);
  const [savedQuote, setSavedQuote] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showRequirements, setShowRequirements] = useState(false);

  const handleInputChange = (event) => {
    event.persist();
    setInputs({ ...inputs, [event.target.name]: event.target.value });
  };

  const disabled = getUnmetRequirements(quote.menu);
  const pricePending = ['loading', 'error'].includes(quote.selectedDate.priceStatus);
  const saveMessage = pricePending ? 'Please wait for the hire price, or retry the date price above.' : unmetRequirementsMessage(disabled);

  const showFirstUnmet = (unmet) => {
    const firstUnmet = _.head(unmet);
    if (!firstUnmet) {
      return;
    }
    const el = _.reduce(getAnchorIds(firstUnmet, quote.menu), (found, id) => found || document.getElementById(id), null);
    if (!el) {
      return;
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.add('requirement-highlight');
    setTimeout(() => el.classList.remove('requirement-highlight'), 2000);
  };

  // if(config.requiresMainCourse) {
  //   const hasAMain = _.find(quote.menu, {selected: true, is_main: 1});
  //   if(typeof hasAMain === "undefined") {
  //     disabled.push(hasAMain);
  //   }
  // }




  const submitForm = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (loading || pricePending) return;
    const selectedItems = _.orderBy(_.filter(quote.menu ,{selected: true}), '_lft');

    setErrors({});
    setLoading(true);
    axios.post(`${config.appUrl}/api/v2/lead`, {
      first_name: inputs.first_name,
      last_name: inputs.last_name,
      email: inputs.email_address,
      contact_number: inputs.contact_number,
      guests: quote.guests,
      event_date: quote.selectedDate.date.format('DD-MM-YYYY'),
      marketing_source: Cookies.get('utm_source'),
      marketing_medium: Cookies.get('utm_medium'),
      marketing_campaign: Cookies.get('utm_campaign'),
      marketing_term: Cookies.get('utm_term'),
      marketing_channel: 'quote',
      marketing_form: 'myevent_quote',
      gclid: Cookies.get('gclid'),
      key: config.app_id,
      app_id: 2,
      selected_items: selectedItems,
      event_type: quote.eventType,

    }, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        accept: 'application/json',
      },
    })
      .then(({ data }) => {
        setLoading(false);
        setSaved(true);
        setInputs(inputDefault);
        setSavedQuote(data.quote);

        dispatch({
          type: GA_EVENT,
          payload: {
            category: 'Quote',
            action: 'Saved',
            value: data.quote.id || null,
          },
        });

      })
      .catch((error) => {
        setLoading(false);
        setErrors(leadErrors(error));
      });
  };

  const cannotSave = pricePending || _.filter(quote.menu, { selected: true }).length === 0 || disabled.length !== 0;
  const openSave = () => {
    if (cannotSave) {
      setShowRequirements(true);
      showFirstUnmet(disabled);
    } else {
      setShowRequirements(false);
      setModalVisible(true);
    }
  };

  return (
    <div>
      <Modal
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        aria-labelledby="save-quote-modal"
        size="sm"
        className="quote-dialog"
        centered
      >
        <button type="button" className="dialog-close save-dialog-close" aria-label="Close save quote" onClick={() => setModalVisible(false)}>×</button>
        <Modal.Body>
          {loading && (
              <div className="loading-container">
                <div>
                  <FontAwesomeIcon icon={faCircleNotch} size="4x" spin />
                </div>
                <h4 className="mt-3">Saving quote...</h4>
              </div>
          )}
          <form onSubmit={(e) => submitForm(e)} className={loading ? 'd-none' : ''}>
            <h3 id="save-quote-modal">Save your quote</h3>
            {quote.cateringMinimumSpend > 0 &&
                <div className="mb-4">
                  <i>
                    Thank you so much for taking the time to fill out a quote. It looks like you are {moneyFormat(quote.cateringMinimumSpend)} short of your minimum spend on that day. No problem though! You can either have another play around on the quote, or please get in touch with our team to talk it through over a phone call.
                  </i>
                </div>

            }
            {quote.cateringMinimumSpend <= 0 &&
            <p>We need a little information about you to save your quote, this means our team can retrieve it later
              should you wish to continue with your booking at {config.location.name}. You will also receive a copy by
              email.</p>
            }
            {saved && savedQuote && (
                <Alert variant="success">
                  Your quote has been successfully saved, your quote number is <strong>{ savedQuote.id }</strong> for your records.
              </Alert>
            )}
            {!_.isEmpty(errors) && (
                <Alert variant="danger">
                  <ul>
                  {Object.keys(errors).map((val, k) => {
                    return (<li key={k}>{errors[val]}</li>)
                  })}
                  </ul>
                </Alert>
            )}
            <div className="row mb-2">
              <div className="col">
                <label htmlFor="first_name">
                  First Name
                  </label>
                  <input
                    type="text"
                    className={"form-control "+(errors['first_name'] ? 'is-invalid' : '')}
                    id="first_name"
                    name="first_name"
                    value={inputs.first_name}
                    onChange={(e) => handleInputChange(e)}
                    required
                  />

              </div>
            </div>
            <div className="row mb-2">
              <div className="col">
                <div className="form-group">
                    <label htmlFor="last_name">
                    Last Name
                    </label>
                    <input
                      type="text"
                      className={"form-control "+(errors['last_name'] ? 'is-invalid' : '')}
                      id="last_name"
                      name="last_name"
                      value={inputs.last_name}
                      onChange={(e) => handleInputChange(e)}
                      required
                    />

                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col">
                <div className="form-group">
                  <label htmlFor="email_address">
                    Email Address
                  </label>
                    <input
                      type="email"
                      autoComplete="email"
                      className={"form-control "+(errors['email_address'] ? 'is-invalid' : '')}
                      id="email_address"
                      name="email_address"
                      value={inputs.email_address}
                      onChange={(e) => handleInputChange(e)}
                      required
                    />

                </div>
              </div>
            </div>

            {config.showContactNumberField && (
            <div className="row mb-2">
              <div className="col">
                <div className="form-group">
                  <label htmlFor="contact_number">
                    Contact Number
                  </label>
                  <input
                      type="text"
                      className={"form-control "+(errors['contact_number'] ? 'is-invalid' : '')}
                      id="contact_number"
                      name="contact_number"
                      value={inputs.contact_number}
                      onChange={(e) => handleInputChange(e)}
                  />

                </div>
              </div>
            </div>
            )}

            <div className="row">
              <div className="col text-end">
                <Button variant="secondary" onClick={() => setModalVisible(false)} className="mr-3 availability_clear">
                  Close
                </Button>
                {!saved && <button type="submit" className="btn btn-primary ml-3">Save</button>}
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <div className="d-grid gap-2">
        <button type="button" id="final-summary-btn" className={`btn btn-primary final-summary-btn ${cannotSave ? 'btn-grey' : ''}`}
          aria-describedby={showRequirements && cannotSave ? 'save-requirements' : undefined} onClick={openSave}>Save your quote</button>
      </div>
      {total && <div className="mobile-quote-bar">
        <button type="button" className="summary-link" onClick={() => {
          const summary = document.getElementById('quote-summary-heading');
          summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
          summary.focus({ preventScroll: true });
        }}>
          <span>Total <strong aria-live="polite">{total}</strong></span>
          <small>Includes VAT · View summary</small>
        </button>
        <button type="button" className={`btn btn-primary ${cannotSave ? 'btn-grey' : ''}`} onClick={openSave}>Save your quote</button>
        {showRequirements && cannotSave && <p role="status">{pricePending ? saveMessage : unmetRequirementsMessage(disabled.slice(0, 1))}</p>}
      </div>}
      {showRequirements && cannotSave && <p id="save-requirements" className="save-requirements" role="status">{saveMessage}</p>}

    </div>
  );
}

const mapStateToProps = (state) => ({ quote: state.quote, config: state.config });

SubmitQuote.propTypes = {
  total: PropTypes.string,
  dispatch: PropTypes.func,
  config: PropTypes.object.isRequired,
  quote: PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(SubmitQuote);
